<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-13 14:37:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Notification\MessageType\components\newMessageType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-23 17:06:33
-->
<template>
  <normalDialog
    :title="$t('label_essweb_MessageType_list_dialog_newTypeTitle')"
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <inputTextFiledMultiLang
              :bindData="Data.message_type_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  Data.message_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_MessageType_list_dialog_messageTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              v-model="Data.message_type_code"
              maxlength="100"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_messageTypeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="messageType"
              filled
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_messageTypeLabel')
              "
              v-model="Data.message_type"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-sheet class="text-subtitle-2">
              {{
                $t(
                  "label_essweb_MessageType_list_dialog_formEmailGroupTitleLabel"
                )
              }}:
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_emailTemplateLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="emailTemplate"
              filled
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_emailTemplateLabel')
              "
              v-model="Data.mail_mode_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-checkbox
              v-model="Data.is_mail_send"
              class="mt-0"
              :label="
                $t('label_essweb_MessageType_list_dialog_isSendEmailLabel')
              "
              hide-details
              required
            ></v-checkbox>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0">
            <v-sheet class="text-subtitle-2">
              {{
                $t(
                  "label_essweb_MessageType_list_dialog_formPushGroupTitleLabel"
                )
              }}:
            </v-sheet>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_sendEmailTemplateLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="notiTemplate"
              filled
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              dense
              :placeholder="
                $t(
                  'label_essweb_MessageType_list_dialog_sendEmailTemplateLabel'
                )
              "
              v-model="Data.message_mode_uuid"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_MessageType_list_dialog_sendPlatformLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="platform"
              filled
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              dense
              :placeholder="
                $t('label_essweb_MessageType_list_dialog_sendPlatformLabel')
              "
              v-model="Data.message_platform"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
            <v-checkbox
              v-model="Data.is_message_send"
              hide-details
              class="mt-0"
              :label="
                $t(
                  'label_essweb_MessageType_list_dialog_isSendNotificationLabel'
                )
              "
              required
            ></v-checkbox>
          </v-col> </v-row></v-form
    ></template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newMessageType",
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    messageType() {
      return this.$getSelectTrans(this.messageTypeData, "view_fields");
    },
    emailTemplate() {
      return this.$getSelectTrans(this.emailTemplateData, "view_fields");
    },
    notiTemplate() {
      return this.$getSelectTrans(this.notiTemplateData, "view_fields");
    },
    platform() {
      return this.$getSelectTrans(this.platformData, "view_fields");
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.Data = {
          message_type_name: this.$getCommonLangKey(this.companyLang),
          message_type: "",
          mail_mode_uuid: "",
          is_mail_send: false,
          is_message_send: false,
          message_mode_uuid: "",
          message_platform: "",
        };
      }
    },
  },
  data() {
    return {
      messageTypeData: [],
      emailTemplateData: [],
      notiTemplateData: [],
      platformData: [],
      Data: {
        message_type_name: "",
        message_type: "",
        mail_mode_uuid: "",
        is_mail_send: false,
        is_message_send: false,
        message_mode_uuid: "",
        message_platform: "",
      },
    };
  },
  mounted() {
    const that = this;
    this.Data.message_type_name = this.$getCommonLangKey(this.companyLang);
    this.getMessageType();
    this.getEmailTemplate();
    this.getNotificationTemplate();
    this.getPlatform();
  },
  methods: {
    getEmailTemplate: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_mail_mode",
      }).then((res) => {
        that.emailTemplateData = res.data;
      });
    },
    getNotificationTemplate: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_mode",
      }).then((res) => {
        that.notiTemplateData = res.data;
      });
    },
    getPlatform: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_platform",
      }).then((res) => {
        that.platformData = res.data;
      });
    },
    getMessageType: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_message_type",
      }).then((res) => {
        that.messageTypeData = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("new", this.Data);
    },
  },
};
</script>